// extracted by mini-css-extract-plugin
module.exports = {"title":"_2YOVr7","field":"XJ67Ur","return":"_3aEegl XJ67Ur","airline":"iegxhg","flight":"_26dlmO XJ67Ur","timeChangedIcon":"_3oXqyO"};